<template>
  <div class="dropdown-item" @click="itemClick(value)">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "dropitem",
  props:['value'],
  data() {
    return {};
  },
  methods: {
    itemClick(value) {
      // console.log(value)
      //通过this调用当前组件的父级的父级也就是dropdown的showM()方法来进行关闭
      this.$parent.$parent.showM();
      // 调用父级的父级（dropdown）的commitClick方法并传如value值
      this.$parent.$parent.commitClick(value);
  
    },
  },
};
</script>

<style scoped>
 .dropdown-item {
   line-height: 40px; /* 行高40px */
   white-space: nowrap;  /* 不换行 */
   padding: 0 20px; /* 内边距上下为0 左右为20px */
   color: white; /* 字体颜色为灰色 */
   cursor: pointer;  /* 鼠标移入为点击样子 */
 }
  .dropdown-item:hover {
    color: #409eff; /* 字体颜色为蓝色 */
    background-color: #ecf5ff; /* 背景颜色为 浅~~蓝色 非常浅就对了 */
  }
</style>



// WEBPACK FOOTER //
// src/components/drop/dropitem.vue